import BaseExtension from './base';

import { createElement, addClass, removeClass, each, toArray } from '../utils';

import opener from './helpers/clickOpener';
import popover from './helpers/popover';
import createSvg, { HEADPHONE } from '../svgs';

const CN = 'rmp-ext-audio-tracks';
const BUTTON_CN = `${CN}__button`;
const SELECTOR_CN = `${CN}__selector`;
const SELECTOR_OPEN_CN = `${SELECTOR_CN}--open`;

const ITEM_CN = `${CN}__item`;
const ITEM_CHECKED_CN = `${ITEM_CN}--checked`;

export default class AudioTracksExtension extends BaseExtension {
   constructor(player, state, options) {
      super(player, state, options, ['loadeddata', 'audiotrackswitched']);
      this.logger.debug('audio-tracks:extension:creating');

      this.render();
      this.init();

      this.logger.debug('audio-tracks:extension:created');
   }

   render() {
      this.$el = createElement('div', { class: CN });

      this.$button = createElement(
         'button',
         { type: 'button', class: BUTTON_CN },
         this.$el
      );

      this.$selector = createElement('div', { class: SELECTOR_CN, tabindex: -1 }, this.$el);

      createSvg(this.$button, HEADPHONE);
   }

   init() {
      const $button = this.$button,
         $selector = this.$selector,
         reposition = false,
         closeOnClick = true,
         heightControl = true;
      popover(this, { $button, text: this.$t('audio-tracks') });
      opener(this, {
         $button,
         $selector,
         SELECTOR_OPEN_CN,
         reposition,
         closeOnClick,
         heightControl,
         firstFocusItemSelector: `.${ITEM_CN}`
      });
   }

   _renderAudioTracks() {
      // fix RAV-411
      each(toArray(this.$selector.childNodes), (btn) =>
         this.$selector.removeChild(btn)
      );

      const audioTrackIdx = this.player.getAudioTrack();

      const items = [];
      each(this.player.getAudioTracks(), (track, idx) => {
         if (!track || typeof track !== 'object') {
            return;
         }
         const item = createElement(
            'button',
            { type: 'button', class: ITEM_CN },
            this.$selector
         );
         item.textContent = track.name || track.label;

         if (+idx === audioTrackIdx) {
            addClass(item, ITEM_CHECKED_CN);
         }

         this.addEvent(item, 'click', () => {
            each(items, (el) => removeClass(el, ITEM_CHECKED_CN));
            addClass(item, ITEM_CHECKED_CN);
            this.player.setAudioTrack(track.id);
         });
         items.push(item);
      });
   }

   onAudiotrackswitched() {
      this._renderAudioTracks();
   }

   onLoadeddata() {
      if (this.player.isMultiAudioTracks()) {
         this._renderAudioTracks();
      } else {
         this.$el.style.display = 'none';
      }
   }

   getElement() {
      return this.$el;
   }

   destroy() {
      super.destroy();
      const parent = this.$el.parentNode;
      parent.removeChild(this.$el);
      this.$el = null;
   }
}
